<template>
    <div class="submenu-container">
        <ul class="submenu-sections">
            <router-link tag="li" :to="{name:'LibraryTracks', query: $route.query}">
                <a>
                    <h4><span class="text">Tracks</span></h4>
                </a>
            </router-link>
            <router-link tag="li" :to="{name:'LibraryJingles', query: $route.query}">
                <a>
                    <h4><span class="text">Jingles</span></h4>
                </a>
            </router-link>
            <router-link tag="li" :to="{name:'LibraryPodcasts', query: $route.query}">
                <a>
                    <h4><span class="text">Podcasts</span></h4>
                </a>
            </router-link>
        </ul>
        <Pagination 
            :pagination="pagination"
            :sizes="[100, 250, 500, 1000]"
            @page="handlePagination"
            @page-size="handlePageSize"
        />
    </div>
</template>

<script>
    import router from '@/router';
    import EventBus from "@/eventbus";
    import Pagination from '@/components/common/Pagination'
    import {mapState} from 'vuex'
    export default {
        name: "PageSubMenuLibrary",
        router,
        components : { Pagination },
        watch: {
            '$route' () {
                this.$forceUpdate();
            }
        },
        computed:{
             ...mapState({
                currentStation:state => state.currentStation || {},
                pagination : state => state.Search.pagination
            }),
        },
        methods: {
            handlePagination (page) {
                EventBus.$emit("onTracksSearch", page)
            },
            handlePageSize (pageSize) {
                this.$store.dispatch('Search/setPageSize', pageSize)
                EventBus.$emit("onTracksSearch", 1)
            }
        }
    }
</script>

<style scoped>
   
</style>
